import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

import { ChipTypeEnum } from '@app/shared-product/components/usf-chip/models/chip-type.enum';
import { ProductDetailTagsService } from '../../services/product-detail-tags.service';
import { TagProduct } from '../../../shared-product/components/usf-product-tag-list/models/tag-product.model';
import { RecentPurchase } from '@usf/list-types';
import { ProductDetailViewModel } from '../../models/product-detail-view-model';

@Component({
  selector: 'app-product-detail-additional-info',
  templateUrl: './product-detail-additional-info.component.html',
  styleUrls: ['./product-detail-additional-info.component.scss'],
})
export class ProductDetailAdditionalInfoComponent implements OnInit, OnChanges {
  @Input() product: ProductDetailViewModel;
  @Input() isUsdaNutritionFlagOn: boolean;

  chip = ChipTypeEnum;
  recentPurchase: RecentPurchase;
  claimTags: TagProduct[];

  constructor(private productDetailTagsService: ProductDetailTagsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.product?.currentValue) {
      this.updateClaimTags();
    }
  }

  ngOnInit() {
    this.updateClaimTags();
  }

  private updateClaimTags(): void {
    const CLICKABLE = true;
    this.claimTags = this.productDetailTagsService.getClaimTags(
      this.product,
      CLICKABLE,
    );
  }
}
